import './Dashboard.css'
import { PhMenuCard } from 'usbc-web-react-partnerhub-library'
import { serviceLinks } from '../model/ASPLinks';
import { useContext, useEffect } from 'react';
import useManageApi from '../../hooks/useManageApi';
import { UserContext } from '../../store/user-context';

function Dashboard() {

    const { loadId, loading: idLoading } = useManageApi();
    const { setUserInfo } = useContext(UserContext);

    useEffect(() => {
        loadId().then(
            (result) => {
                setUserInfo(result?.data);
            }
        );
    },[])

    return (
        <div className="row g-1 gy-3 pt-0 default-page">
            {serviceLinks.map((link, index) => {
                let model = {
                    ...link
                };
                return link.displayName != 'Dashboard'
                    && <PhMenuCard key={index} link={model} />
            }
            )}
        </div >
    )
}

export default Dashboard